import { handleError } from '../../../../redux/actions/common-message/message-action';
import { makeApiCall } from '../../../../redux/actions/common/common-action';
import { API_URL } from '@Utils/config';
import {
  ADD_RECIPIENT,
  FLOW_TYPE_PROFILE,
  FLOW_TYPE_TRANSACTION
} from '@Utils/constants/eventsConstants';
import { BeneDetails, LogBeneDetailsType } from '../../utils/interface';
import { SECONDARY_ROUTING_CODE_PLACEHOLDER } from '../../utils/constants';
import { logEvent } from '../../../../utils/events/logUserEvents';
import { LOG_TYPE } from '../../../../utils/events/eventsConstants';

export const getSecondaryRoutingCode = (countryCode: string, currencyCode: string) => {
  return async (dispatch: (data: any) => void): Promise<any> => {
    try {
      const response = await makeApiCall({
        method: 'get',
        url: `${API_URL}/niumForex/remitter/beneficiary/routing`,
        withCredentials: true,
        params: { country_code: countryCode, currency_code: currencyCode }
      });
      return response?.data;
    } catch (err) {
      dispatch(handleError(err));
      throw err;
    }
  };
};

export const addNiumForexBene = (data: BeneDetails) => {
  return async (dispatch: (data: any) => void): Promise<any> => {
    try {
      const response = await makeApiCall({
        method: 'post',
        url: `${API_URL}/niumForex/remitter/beneficiary`,
        withCredentials: true,
        data
      });
      return response?.data;
    } catch (err) {
      dispatch(handleError(err));
      throw err;
    }
  };
};

export const updateNiumForexBene = (beneficiaryId: number, data: BeneDetails) => {
  return async (dispatch: (data: any) => void): Promise<any> => {
    try {
      const response = await makeApiCall({
        method: 'patch',
        url: `${API_URL}/niumForex/remitter/beneficiary/${beneficiaryId}`,
        withCredentials: true,
        data
      });
      return response?.data?.data;
    } catch (err) {
      dispatch(handleError(err));
      throw err;
    }
  };
};

export const logAddRecipientEvent = (data: LogBeneDetailsType, isSendMoneyFlow = false): void => {
  const flowType = isSendMoneyFlow ? FLOW_TYPE_TRANSACTION : FLOW_TYPE_PROFILE;
  const ctData = {
    pageName: ADD_RECIPIENT,
    ...data
  };
  logEvent('nfAddRecipient', flowType, ctData, LOG_TYPE.CLEVER_TAP);
};

export const SECONDARY_ROUTING_INITIAL_VALUE = {
  showSecondaryRoutingCode: false,
  secondaryRoutingCodePlaceHolder: '',
  secondaryRoutingCodeType: '',
  validations: null,
  isAccountNumberRequired: false
};

export const getSecondaryRoutingCodePlaceHolder = (secondaryRoutingCode: string): string => {
  return SECONDARY_ROUTING_CODE_PLACEHOLDER[
    secondaryRoutingCode as keyof typeof SECONDARY_ROUTING_CODE_PLACEHOLDER
  ];
};
